import React, { useState, useEffect, forwardRef } from "react";
import FullCalendar, { constrainPoint } from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import interactionPlugin from '@fullcalendar/interaction'; // a plugin!
import { ko } from "date-fns/locale";
import {
    Box, Select, MenuItem, FormControl, InputLabel, Dialog,
    AppBar, Toolbar, IconButton,
    Typography
} from "@mui/material";
import CenterSelect from "./CenterSelect";
import { configState, loginState } from "../lib/State";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import axios from "axios";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import moment from "moment";
import add_comma from "../lib/add_comma";
import remove_comma from "../lib/remove_comma";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import pr from "../lib/pr";
import styled from "@emotion/styled";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { brown, green, blue, orange, purple, red } from '@mui/material/colors';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper
} from '@mui/material';

const token = get_token();
const cid = get_cid();

const Container = styled(Box)`
    .MuiTypography-body1 { font-size: 14px; }
`;

export default function ReportCardDialogStat(props) {
    
    const {login, sdate, edate, tcid} = props;
    const [rows, setRows] = useState([]);
    const [sum, setSum] = useState({
        origin_price:0,
        sale_price:0,
        count:0,
    })

    const load_data = async () => {
        let i=0;     
        let sum_origin_price=0;
        let sum_sale_price=0;   
        let sum_count=0;
        let result = await axios.post(configState.api + '/chart/report_card_stat', {
            token: token,
            mcd: login.mcd,
            cid: cid,
            tcid: tcid,
            sdate: sdate,
            edate: edate,
            level: login.level,
        });
        if (result.data.success === 1) {
            setRows(result.data.rows);

            // 합계
            for(i=0; i<result.data.rows.length;i++) {
                sum_origin_price = sum_origin_price + parseInt(result.data.rows[i].origin_price);                
                sum_sale_price = sum_sale_price + parseInt(result.data.rows[i].sale_price);                                
                sum_count = sum_count + parseInt(result.data.rows[i].count);                                
            }
            setSum({
                origin_price: sum_origin_price,
                sale_price: sum_sale_price,
                count: sum_count,
            })
        }
    }

    useEffect(() => {
        load_data();
    }, []);


    return <Container p={1}>
        <Box mt={1}>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ background: brown[200] }}>
                            <TableCell sx={{ textAlign:"center", width: 200 }}><Typography>상품명</Typography></TableCell>
                            <TableCell sx={{ textAlign:"center", width: 100 }}><Typography>수량</Typography></TableCell>
                            <TableCell sx={{ textAlign:"center", width: 160 }}><Typography>상품가</Typography></TableCell>
                            <TableCell sx={{ textAlign:"center", width: 160 }} ><Typography>판매가</Typography></TableCell>
                            <TableCell><Typography>&nbsp;</Typography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((item, key) => {
                            return <TableRow key={key}>
                                <TableCell sx={{ textAlign:"center"}}><Typography>{item.pname}</Typography></TableCell>
                                <TableCell sx={{ textAlign:"center"}}><Typography>{add_comma(item.count)}</Typography></TableCell>
                                <TableCell sx={{ textAlign:"right"}}><Typography>{add_comma(item.origin_price)}</Typography></TableCell>
                                <TableCell sx={{ textAlign:"right"}}><Typography>{add_comma(item.sale_price)}</Typography></TableCell>
                                <TableCell><Typography>&nbsp;</Typography></TableCell>
                            </TableRow>
                        })}

                            <TableRow sx={{ background: brown[50]}}>
                                <TableCell sx={{ textAlign:"center"}}><Typography>합계</Typography></TableCell>
                                <TableCell sx={{ textAlign:"center"}}><Typography>{sum.count}</Typography></TableCell>
                                <TableCell sx={{ textAlign:"right"}}><Typography>{add_comma(sum.origin_price)}</Typography></TableCell>
                                <TableCell sx={{ textAlign:"right"}}><Typography>{add_comma(sum.sale_price)}</Typography></TableCell>
                                <TableCell><Typography>&nbsp;</Typography></TableCell>
                            </TableRow>
                    </TableBody>
                    
                        
                            
                       
                   
                </Table>
            </TableContainer>
        </Box>
    </Container>

}